import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css";

function Navbar() {
  const { user, logout, hasPermission } = useAuth();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [unviewedBroadcasts, setUnviewedBroadcasts] = useState(0);
  const [unviewedRequests, setUnviewedRequests] = useState(0);

  const isActive = (path) => (location.pathname === path ? "active" : "");

  useEffect(() => {
    fetchUnviewedCounts();
    // Poll every 30 seconds for new notifications
    const interval = setInterval(fetchUnviewedCounts, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchUnviewedCounts = async () => {
    try {
      const [broadcastsRes, requestsRes] = await Promise.all([
        api.get("/broadcasts/unviewed/count"),
        api.get("/requests/unviewed/count"),
      ]);
      setUnviewedBroadcasts(broadcastsRes.data.count);
      setUnviewedRequests(requestsRes.data.count);
    } catch (error) {
      console.error("Error fetching unviewed counts:", error);
    }
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="mobile-header">
        <h2>HRMS</h2>
        <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "✕" : "☰"}
        </button>
      </div>

      <div
        className={`mobile-overlay ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>

      <nav className={`navbar ${isOpen ? "open" : ""}`}>
        <div className="navbar-container">
          <div className="navbar-brand">
            <Link to="/" onClick={handleLinkClick}>
              HRMS
            </Link>
          </div>

          <div className="navbar-menu">
            <Link to="/" className={isActive("/")} onClick={handleLinkClick}>
              Dashboard
            </Link>
            <Link
              to="/broadcasts"
              className={isActive("/broadcasts")}
              onClick={handleLinkClick}
            >
              Broadcasts{" "}
              {unviewedBroadcasts > 0 && (
                <span className="notification-badge">{unviewedBroadcasts}</span>
              )}
            </Link>
            <Link
              to="/projects"
              className={isActive("/projects")}
              onClick={handleLinkClick}
            >
              Projects
            </Link>

            <Link
              to="/goals"
              className={isActive("/goals")}
              onClick={handleLinkClick}
            >
              Goals
            </Link>
            <Link
              to="/assets"
              className={isActive("/assets")}
              onClick={handleLinkClick}
            >
              Assets
            </Link>
            <Link
              to="/leaves"
              className={isActive("/leaves")}
              onClick={handleLinkClick}
            >
              Leaves
            </Link>
            <Link
              to="/requests"
              className={isActive("/requests")}
              onClick={handleLinkClick}
            >
              Requests{" "}
              {unviewedRequests > 0 && (
                <span className="notification-badge">{unviewedRequests}</span>
              )}
            </Link>
            <Link
              to="/attendance"
              className={isActive("/attendance")}
              onClick={handleLinkClick}
            >
              Attendance
            </Link>
            <Link
              to="/leads"
              className={isActive("/leads")}
              onClick={handleLinkClick}
            >
              My Leads
            </Link>
            {hasPermission("employees", "read") && (
              <Link
                to="/history"
                className={isActive("/history")}
                onClick={handleLinkClick}
              >
                History
              </Link>
            )}
            {hasPermission("employees", "read") && (
              <Link
                to="/employees"
                className={isActive("/employees")}
                onClick={handleLinkClick}
              >
                Employees
              </Link>
            )}
            {hasPermission("documents", "update") && (
              <Link
                to="/documents"
                className={isActive("/documents")}
                onClick={handleLinkClick}
              >
                Document
              </Link>
            )}
            {hasPermission("my-documents", "read") && (
              <Link
                to="/my-documents"
                className={isActive("/my-documents")}
                onClick={handleLinkClick}
              >
                My Documents
              </Link>
            )}
            {hasPermission("roles", "read") && (
              <Link
                to="/roles"
                className={isActive("/roles")}
                onClick={handleLinkClick}
              >
                Roles
              </Link>
            )}
            {hasPermission("sales", "read") && (
              <Link
                to="/sales-teams"
                className={isActive("/sales-teams")}
                onClick={handleLinkClick}
              >
                Sales Teams
              </Link>
            )}
            {(user?.role?.name === 'Sales' || user?.role?.name === 'HR' || user?.role?.name === 'Admin') && (
              <Link
                to="/sales-reports"
                className={isActive("/sales-reports")}
                onClick={handleLinkClick}
              >
                Sales Reports
              </Link>
            )}

            {/* Added Payroll Management Section Below */}
            {hasPermission('payroll', 'read') && (
              <Link
                to="/payroll"
                className={isActive('/payroll')}
                onClick={handleLinkClick}
              >
                Payroll
              </Link>
            )}

            {/* Added Payroll Management Section Below */}
            {hasPermission('devices', 'read') && (
              <Link
                to="/devices"
                className={isActive('/devices')}
                onClick={handleLinkClick}
              >
                Devices
              </Link>
            )}

            {hasPermission('biometric-attendance', 'read') && (
              <Link
                to="/biometric-attendance"
                className={isActive('/biometric-attendance')}
                onClick={handleLinkClick}
              >
                Biometric Attendance
              </Link>
            )}


            {/* My Payslip - Employees Only */}
            {hasPermission('my-payslips', 'read') && (
              <Link
                to="/my-payroll"
                className={isActive('/my-payroll')}
                onClick={handleLinkClick}
              >
                My Payslip
              </Link>
            )}
          </div>

          <div className="navbar-user">
            <Link
              to="/profile"
              className="user-profile"
              onClick={handleLinkClick}
            >
              {user?.firstName} {user?.lastName}
            </Link>
            <button
              onClick={() => {
                logout();
                setIsOpen(false);
              }}
              className="btn btn-secondary"
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;